import { Form, useFormikContext } from 'formik';
import React from 'react';

import { EntityDetailsFields } from 'common/components/entity-details';
import { useStore } from 'core/store';
import { ErrorAlert } from '../quote-errors';
import { offerDetailsCodes } from '../quote-forms/quote-forms.constants';

const OfferDetails = () => {
  const {
    quote: { getAlerts }
  } = useStore();

  const { values } = useFormikContext();

  const alerts = getAlerts(offerDetailsCodes, values.policyType);

  return (
    <Form>
      {alerts.length > 0 && <ErrorAlert alerts={alerts} id="error-alert-offer-details" />}
      <EntityDetailsFields title="Offer Details" />
    </Form>
  );
};

export default OfferDetails;
